import { render, staticRenderFns } from "./DropdownView.vue?vue&type=template&id=5e280809&scoped=true&"
import script from "./DropdownView.vue?vue&type=script&lang=js&"
export * from "./DropdownView.vue?vue&type=script&lang=js&"
import style0 from "./DropdownView.vue?vue&type=style&index=0&id=5e280809&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e280809",
  null
  
)

export default component.exports